import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../App';
import Icon from '../components/Icon';

const SECTIONS = [
  { icon: 'note', title: 'Notes', desc: 'Short, clear notes for every topic.' },
  { icon: 'blog', title: 'Blogs', desc: 'Study tips and exam guidance.' },
  { icon: 'update', title: 'Updates', desc: 'Latest news and announcements.' },
  { icon: 'instruction', title: 'Instructions', desc: 'What to do and how to do it.' },
  { icon: 'video', title: 'Videos', desc: 'Watch lessons online, anytime.' },
  { icon: 'query', title: 'Queries', desc: 'Ask your doubts and get answers.' },
  { icon: 'personal', title: 'Personal Sessions', desc: 'Book a 1-on-1 class.' },
  { icon: 'group', title: 'Group Meetings', desc: 'Join live group classes.' },
];

export default function Home() {
  const { user } = useAuth();
  if (user) return <Navigate to="/hub" />;

  return (
    <div className="home-simple">
      <h1>Welcome to MK<span>Classes</span></h1>
      <p>Everything you need to study, all in one place.</p>
      <div className="home-simple__actions">
        <Link to="/register" className="btn-cta-primary">Sign up as a student</Link>
        <Link to="/login" className="btn-cta-outline">Log in</Link>
      </div>

      <div className="home-simple__grid">
        {SECTIONS.map((s) => (
          <div key={s.title} className="home-simple__card">
            <span className="icon-badge"><Icon name={s.icon} size={22} /></span>
            <strong>{s.title}</strong>
            <span>{s.desc}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
